import type { BoneLoss, Mobility, Plaque, ToothState } from './types';

export const getToothStateLabel = (toothState?: ToothState | null) => {
  switch (toothState) {
    case 'MISSING':
    case 'PONTIC': // A pontic is an artificial tooth, so we can mark tooth as missing
      return 'M';
    case 'IMPLANT':
      return 'I';
    case 'IMPACTED':
      return 'IMP';
    case 'NORMAL':
    case 'UNKNOWN':
    default:
      return null;
  }
};

export const getPlaqueLabel = (plaque?: Plaque | null) => {
  switch (plaque) {
    case 'SLIGHT':
      return 1;
    case 'MODERATE':
      return 2;
    case 'HEAVY':
      return 3;
    case 'NONE':
    case 'UNKNOWN':
    default:
      return null;
  }
};

export const getMobilityLabel = (mobility?: Mobility | null) => {
  switch (mobility) {
    case 'CLASS_I':
      return 1;
    case 'CLASS_II':
      return 2;
    case 'CLASS_III':
      return 3;
    case 'NONE':
    case 'UNKNOWN':
    default:
      return null;
  }
};

export const getBoneLossLabel = (boneLoss?: BoneLoss | null) => {
  switch (boneLoss) {
    case 'SLIGHT':
      return 1;
    case 'MODERATE':
      return 2;
    case 'SEVERE':
      return 3;
    case 'NONE':
    case 'UNKNOWN':
    default:
      return null;
  }
};

// DCM (distal, center, mesial) should be flipped at the midline
export const isReverseOrderDcm = (toothNumber: string | null): boolean => {
  if (!toothNumber) return false;
  const parsedToothNumber = parseInt(toothNumber);
  return parsedToothNumber >= 9 && parsedToothNumber <= 24;
};
